module.exports = __webpack_public_path__ + "static/media/chip.06b0c4f9.svg";